import { render, staticRenderFns } from "./ad-edit.vue?vue&type=template&id=ca609900&scoped=true&"
import script from "./ad-edit.vue?vue&type=script&lang=js&"
export * from "./ad-edit.vue?vue&type=script&lang=js&"
import style0 from "./ad-edit.vue?vue&type=style&index=0&id=ca609900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca609900",
  null
  
)

export default component.exports